(function () {
    'use strict';

    var app = angular.module('inoApp');
    app.directive('progressIndicator', ['$timeout', '$interval', function ($timeout, $interval) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            template: '<div class="progress-container"><div class="progress-baritem" ng-repeat="item in items" ng-class="{\'large\': item.isCurrent}"></div></div>',
            controller: ['$scope', function ($scope) {
                var items = $scope.items = [];
                var index = $scope.index = 0;
                var isIncrementing = $scope.isIncrementing = true;
                var interval = $scope.interval = null;
                var isStopped = false; // once stopped, it cannot restart

                this.start = function () {
                    if (interval !== null)
                        stop();
                    if (isStopped)
                        return;

                    interval = $interval(function () {
                        items[index].isCurrent = false;
                        if (isIncrementing && index + 1 == items.length)
                            isIncrementing = false;
                        else if (!isIncrementing && index - 1 == -1)
                            isIncrementing = true;
                        index = isIncrementing ? index + 1 : index - 1;
                        items[index].isCurrent = true;
                    }, 300);
                }
                this.addItem = function (item) {
                    $scope.items.push(item);
                }
                this.stop = function () {
                    $interval.cancel(interval);
                    isStopped = true;
                }
            }],
            link: { pre: link },
            scope: {}
        };
        function link(scope, element, attrs, controller) {
            var itemAmount = attrs.items == null ? 5 : attrs.items;
            for (var iCnt = 0; iCnt < itemAmount; iCnt++)
                controller.addItem({
                    isCurrent: (iCnt == 0)
                });
            // When element destoyed, call stop() to end interval
            element.on('$destroy', function () {
                controller.stop();
            });
            // Call start() after render
            $timeout(function () {
                controller.start();
            });
        }
    }]);
})();